import { defineStore } from 'pinia';
import { isSessionResponse, type SessionUser } from '@calloneer/contracts';
import { apiRequest, isNull } from '../api.js';

export const useSessionStore = defineStore('session', {
  state: (): { loading: boolean; user: SessionUser | null } => ({ loading: true, user: null }),
  getters: {
    authenticated: (state): boolean => state.user !== null,
    isSuperadmin: (state): boolean => state.user?.role === 'SUPERADMIN',
  },
  actions: {
    async load(): Promise<void> {
      const session = await apiRequest({ path: '/v1/auth/session', guard: isSessionResponse });
      this.user = session.user;
      this.loading = false;
    },
    login(): void {
      window.location.assign('/v1/auth/google/start');
    },
    async logout(): Promise<void> {
      await apiRequest({ path: '/v1/auth/logout', method: 'POST', guard: isNull });
      this.user = null;
      window.location.assign('/login');
    },
  },
});
